  function handleQueryParameters() {
    var queryStr = window.location.search;
    var paramPairs = queryStr.substr(1).split('&');
    var params = {};

    for (var i = 0; i < paramPairs.length; i++) {
        var parts = paramPairs[i].split('=');
        params[parts[0]] = parts[1];
        // ./beam-designer.html?login=true
        if (parts[0] == 'login' && parts[1] == 'true') {
            openSigninModal();
        } else if (parts[0] == 'sign-up' && parts[1] == 'true') {
            openSignupModal();
        }
    }
}

function customerGate() {
    if (customerLevel === "pro") {
        return false;
    }
    if (customerLevel === "basic") {
        openFinishUpgradeModal();
        return true;
    }
    // free or not set
    openSignupModal();
    return true;
}

window.customerGate = customerGate

window.onbeforeprint = function () {
    redrawCanvas(activeProject, true)
}

window.onafterprint = function () {
    redrawCanvas(activeProject, false)
}

window.addEventListener("beforeunload", function (e) {
    if (activeProject.isModified === false) {
        return undefined;
    }

    var confirmationMessage = 'Your project needs to be saved. '
        + 'If you leave before saving, your changes will be lost.';

    (e || window.event).returnValue = confirmationMessage; //Gecko + IE
    return confirmationMessage; //Gecko + Webkit, Safari, Chrome etc.
});

document.addEventListener('customer-logged-in', (event) => {
    // configure / debug options
    firebase.database().ref('/users/' + firebase.auth().currentUser.uid).once('value').then(function(snapshot) {
        if(snapshot.val().settings) {
            let settings = snapshot.val().settings
            const debugExport = settings.debugExport
            if(debugExport) {
                document.getElementById("export-component-div").classList.remove('d-none')
            } else {
                document.getElementById("export-component-div").classList.add('d-none')
            }
        }
    })
})

document.addEventListener('on-logout-success', () => {
    resetActiveProject();
})

document.addEventListener('project-changed', (event) => {
    document.getElementById('project-title').innerHTML = activeProject.title
    updateLoadTable()
    updateActiveProjectItem()
    updateActionCards()
    markBeamDesignNeedsSaved()
    autoBeamFlexureDesign()
    redrawCanvas(activeProject, event.detail)
})

document.addEventListener('project-loaded', (event) => {
    document.getElementById('project-title').innerHTML = activeProject.title
    updateActiveProjectItem()
    updateActionCards()
    updateLoadTable()
    setUnits()
    markBeamDesignNeedsSaved()
    autoBeamFlexureDesign()
    redrawCanvas(activeProject, event.detail)
})

document.addEventListener('redraw-canvases', (event) => {
    redrawCanvas(activeProject, event.detail)
})

/*****************************
 * Menu
 ****************************/
window.openNewBeamDialog = () => {
    if(customerGate()) { return; }
    if(activeProject.isNewProject === true) {
        bootstrap.Modal.getOrCreateInstance('#modal-new-beam-dialog').show()
    } else if(activeProject.isModified === false) {
        saveDesignAndStartNew();
    } else {
        // update button action to save and start new
        // load-project-confirm-button
        $("#load-project-confirm-button").attr("onclick", "saveDesignAndStartNew();");
        $('#modal-change-projects-dialog').modal('show');
    }
}

window.openFileExlporerDialog = () => {
    if(customerGate()) { return; }
    document.getElementById("file-explorer-table").innerHTML = "<em>Loading...</em>";
    openFileExplorerDialog();
}

window.openMakeCopyDialog = () => {
    if(customerGate()) { return; }
    if(activeProject.isModified === false) {
        makeCopyOfProject();
    } else {
        // update button action to save and start new
        // load-project-confirm-button
        $("#load-project-confirm-button").attr("onclick", "makeCopyOfProject();");
        $('#modal-change-projects-dialog').modal('show');
    }
}

window.printBeamDesign = () => {
    if(customerGate()) { return; }
    window.print();
}

window.openDeleteProjectDialog = () => {
    if(customerGate()) { return; }
    bootstrap.Modal.getOrCreateInstance('#modal-delete-project-dialog').show()
}

window.openPrintPreferencesDialog = () => {
    if(customerGate()) { return; }
    updatePrintPreferencesDialogFields()
    bootstrap.Modal.getOrCreateInstance('#modal-print-preferences-dialog').show()
}

window.loadProjectClicked = (uuid) => {
    if(activeProject.isModified === false) {
        loadProject(uuid);
    } else {
        var loadProjectFunctionStr = "loadProject('" + uuid + "');";
        $("#load-project-confirm-button").attr("onclick", loadProjectFunctionStr);
        $('#modal-change-projects-dialog').modal('show');
    }
}

/*****************************
 * Active Project Item
 ****************************/
function updateActiveProjectItem() {
    document.getElementById('active-project-title').innerHTML = activeProject.title
    document.getElementById('active-project-shape').innerHTML = activeProject.shapeName
    document.getElementById('active-project-design-spec').innerHTML = activeProject.designTypeStr
    document.getElementById('active-project-timeago').innerHTML = `Created ${timeago().format(activeProject.createdAt)}`
    
    jQuery(".tm-input").tagsManager('empty')
    // disable event handler while we load up the tag manager.
    jQuery(".tm-input").off('tm:pushed')
    activeProject.tags.forEach(function(e) {
      jQuery(".tm-input").tagsManager('pushTag', e);
      if(!(e in allProjectLabels)) {
        allProjectLabels[e] = {enabled: false};
      }
    })

    // now add the event handler back
    jQuery(".tm-input").on('tm:pushed', function(e, tag) {
      activeProject.tags = jQuery(".tm-input").tagsManager('tags');
      markBeamDesignNeedsSaved()
    })
}

/*****************************
 * Action Cards
 ****************************/
function updateActionCards() {
    updateMaterialCard()
    updateShapeCard()
    updateDesignCard()
    updateSpanCard()
    updateLoadCard()
    updateBracingCard()

    // temporary - udate material and shape dialog headers
    const shapeName = activeProject.shapeName
    const materialName = activeProject.isCustom ||  activeProject.isEngineeredLumber ? "" : activeProject.materialName;
    document.getElementById('current-selected-shape').innerHTML = `${shapeName} ${materialName}`
    document.getElementById('material-selected-shape').innerHTML = `${shapeName} ${materialName}`

    // temporary - update rotation button visibility
    if(isSteelShape(activeProject.shape) && isHssRectangleShape(activeProject.shape)) {
        document.getElementById("beam-rotation-button-group").classList.remove("d-none")
    } else {
        document.getElementById("beam-rotation-button-group").classList.add("d-none")
    }
}

function updateMaterialCard() {
    document.getElementById('material-panel-text').innerHTML = activeProject.materialName
}

function updateShapeCard() {
    let str = activeProject.shapeName;
    if(activeProject.isEngineeredLumber === false) {
        const shapeIString = activeProject.beam.crossSectionRotation === 0 ? activeProject.shapeIxString : activeProject.shapeIyString
        str += ` (${shapeIString})`
    }
    document.getElementById('shape-panel-text').innerHTML = str
}

function updateDesignCard() {
    document.getElementById('design-panel-text').innerHTML = activeProject.designTypeStr
}

function updateSpanCard() {
    document.getElementById('span-panel-text').innerHTML = (activeProject.beam.spans.length === 1) ? "1 Span" : activeProject.beam.spans.length + " Spans"
}

function updateLoadCard() {
    var nLoads = activeProject.beam.totalNumberOfLoads;
    document.getElementById('load-panel-text').innerHTML = (nLoads === 1) ? "1 Load" : nLoads + " Loads"
}

function updateBracingCard() {
    document.getElementById('bracing-panel-text').innerHTML = activeProject.bracingStr
}

/***********************************
 **** Shape and material dialog ****
 ***********************************/
document.addEventListener('north-american-steel-shape-selected', (event) => {
    const shape = event.detail
    designConfigurator.northAmericanSteelShape = shape;
    designConfigurator.northAmericanSteelSelected();
    onShapeOrMaterialChanged();
    markBeamDesignNeedsSaved();
})

document.addEventListener('european-steel-shape-selected', (event) => {
    if (customerGate()) { return; }
    const shape = event.detail
    designConfigurator.europeanSteelShape = shape;
    designConfigurator.europeanSteelSelected();
    onShapeOrMaterialChanged();
})

document.addEventListener('wood-shape-selected', (event) => {
    const shape = event.detail
    designConfigurator.woodShape = shape
    designConfigurator.woodSelected()
    onShapeOrMaterialChanged()
    markBeamDesignNeedsSaved()
})

document.addEventListener('engineered-lumber-shape-selected', (event) => {
    if (customerGate()) { return; }
    const shape = event.detail
    designConfigurator.engineeredLumberShape = shape
    designConfigurator.engineeredLumberSelected()
    onShapeOrMaterialChanged()
    markBeamDesignNeedsSaved()
})

document.addEventListener('flitch-updated', (event) => {
    const flitch = event.detail
    if (activeProject.isWood) {
        if (flitch) {
            designConfigurator.woodShape.flitch = flitch
        } else {
            delete designConfigurator.woodShape.flitch
        }
        designConfigurator.woodSelected()
    } else if (activeProject.isEngineeredLumber) {
        if (flitch) {
            designConfigurator.engineeredLumberShape.flitch = flitch
        } else {
            delete designConfigurator.engineeredLumberShape.flitch
        }
        designConfigurator.engineeredLumberSelected()
    }
    onShapeOrMaterialChanged()
    markBeamDesignNeedsSaved()
})

document.addEventListener('custom-soldier-shape-selected', (event) => {
    if (customerGate()) { return; }
    const shape = event.detail
    designConfigurator.customSoldierShape = shape;
    designConfigurator.customSoldierSelected();
    onShapeOrMaterialChanged()
    markBeamDesignNeedsSaved()
})

document.addEventListener('custom-aluminum-shape-selected', (event) => {
    if (customerGate()) { return; }
    const shape = event.detail
    designConfigurator.customAluminumShape = shape;
    designConfigurator.customAluminumSelected();
    onShapeOrMaterialChanged();
})

document.addEventListener('custom-shape-selected', (event) => {
    if (customerGate()) { return; }
    const shape = event.detail
    designConfigurator.customShape = shape;
    designConfigurator.customMaterial = shape;
    designConfigurator.customShapeSelected();
    activeProject.design.designType = 'None';
    activeProject.customShape = shape;
    onShapeOrMaterialChanged();
    markBeamDesignNeedsSaved();
})

document.addEventListener('custom-shape-unselected', () => {
    if (customerGate()) { return; }
    designConfigurator.northAmericanSteelSelected();
    activeProject.design.designType = 'None';
    onShapeOrMaterialChanged();
    markBeamDesignNeedsSaved();
})

document.addEventListener('north-american-steel-material-selected', (event) => {
    const material = event.detail
    designConfigurator.northAmericanSteelMaterial = material;
    designConfigurator.northAmericanSteelSelected();
    onShapeOrMaterialChanged();
    markBeamDesignNeedsSaved();
})

document.addEventListener('european-steel-material-selected', (event) => {
    if (customerGate()) { return; }
    const material = event.detail
    designConfigurator.europeanSteelMaterial = material;
    designConfigurator.europeanSteelSelected();
    activeProject.design.designType = 'None';
    onShapeOrMaterialChanged();
    markBeamDesignNeedsSaved();
})

document.addEventListener('astm-steel-material-selected', (event) => {
    if (customerGate()) { return; }
    const material = event.detail
    designConfigurator.customSoldierMaterial = material;
    designConfigurator.customSoldierSelected();
    activeProject.design.designType = 'None';
    onShapeOrMaterialChanged();
    markBeamDesignNeedsSaved();
})

document.addEventListener('aluminum-material-selected', (event) => {
    if (customerGate()) { return; }
    const material = event.detail
    designConfigurator.customAluminumMaterial = material;
    designConfigurator.customAluminumSelected();
    activeProject.design.designType = 'None';
    onShapeOrMaterialChanged();
    markBeamDesignNeedsSaved();
})

document.addEventListener('wood-material-selected', (event) => {
    const material = event.detail
    designConfigurator.woodMaterial = material
    designConfigurator.woodSelected()
    onShapeOrMaterialChanged()
    markBeamDesignNeedsSaved()
    $('#modal-material-selector-dialog').modal('toggle');
})

document.addEventListener('plys-changed', (event) => {
    if(customerGate()) { 
        bootstrap.Modal.getOrCreateInstance('#modal-shape-selector-dialog').hide()
        return 
    }
    BeamManager.updateNumberOfPlys(activeProject, event.detail)
    markBeamDesignNeedsSaved()
    autoBeamFlexureDesign()
})

document.addEventListener('load-added-or-updated', () => {
    updateLoadCard()
    updateLoadTable();
    autoBeamFlexureDesign();
})

document.addEventListener('bracing-changed', () => {
    updateBracingCard()
    autoBeamFlexureDesign();
})

/***********************
 **** Design dialog ****
 **********************/
document.getElementById('lrfd-combinations-button').onclick = () => {
    activeProject.design.designType = 'LRFD'
    activeProject.design.loadCombination = lrfdCombinations
    markBeamDesignNeedsSaved()
    updateDesignCard()
    autoBeamFlexureDesign()
    document.dispatchEvent(new CustomEvent('design-type-did-change', {detail: activeProject}))
}

document.getElementById('asd-combinations-button').onclick = () => {
    activeProject.design.designType = 'ASD'
    activeProject.design.loadCombination = asdCombinations
    markBeamDesignNeedsSaved()
    updateDesignCard()
    autoBeamFlexureDesign()
    document.dispatchEvent(new CustomEvent('design-type-did-change', {detail: activeProject}))
}

document.getElementById('no-combinations-button').onclick = () => {
    activeProject.design.designType = 'None'
    activeProject.design.loadCombination = noCombinations
    markBeamDesignNeedsSaved()
    updateDesignCard()
    autoBeamFlexureDesign()
    document.dispatchEvent(new CustomEvent('design-type-did-change', {detail: activeProject}))
}

document.getElementById('use-load-combo-equations').onclick = () => {
    const useEquations = document.getElementById('use-load-combo-equations').checked
    if(useEquations === false) {
        activeProject.design.loadCombination = noCombinations;
    } else if(activeProject.isLRFD) {
        activeProject.design.loadCombination = lrfdCombinations;
    } else if(activeProject.isASD) {
        activeProject.design.loadCombination = asdCombinations;
    }
    document.dispatchEvent(new CustomEvent('use-load-combo-did-change', {detail: activeProject}))
    markBeamDesignNeedsSaved()
    updateDesignCard()
    autoBeamFlexureDesign()
}

document.getElementById('use-lambda-or-cd').onclick = () => {
    let useLambda = document.getElementById('use-lambda-or-cd').checked
    activeProject.design.useLambdaOrCd = useLambda
    document.dispatchEvent(new CustomEvent('use-lambda-or-cd-did-change', {detail: activeProject}))
    markBeamDesignNeedsSaved()
    updateDesignCard()
    autoBeamFlexureDesign()
}

document.addEventListener('lambda-or-cd-changed', (event) => {
    activeProject.design.updateLambdaOrCd(event.detail.equationName, event.detail.value)
    markBeamDesignNeedsSaved()
})

document.getElementById('use-repetitive-member-factor').onclick = () => {
    let useRepetitiveMemberFactor = document.getElementById('use-repetitive-member-factor').checked
    activeProject.design.useRepetitiveMemberFactor = useRepetitiveMemberFactor
    markBeamDesignNeedsSaved()
    updateDesignCard()
    autoBeamFlexureDesign()
}

document.addEventListener('toggle-load-combination-equation', (event) => {
    activeProject.design.loadCombination.togglePrettyExclude(event.detail)
})

document.addEventListener('design-deflection-limits-changed', (event) => {
    const deflectionLimits = event.detail
    activeProject.design.liveLoadLimit = deflectionLimits.liveLoadLimit
    activeProject.design.deadPlusLiveLoadLimit = deflectionLimits.deadPlusLiveLoadLimit
    activeProject.design.snowOrWindLoadLimit = deflectionLimits.snowOrWindLoadLimit
    activeProject.design.totalLoadLimit = deflectionLimits.totalLoadLimit
    markBeamDesignNeedsSaved();
    autoBeamFlexureDesign();
});

/***********************
 **** Span dialog ****
 **********************/
function addLeftSpan() {
    const length = activeProject.beam.spans[0].length()
    if(!isNaN(length) && BeamManager.addLeftSpan(activeProject, length)) {
        document.dispatchEvent(new CustomEvent('spans-did-change', {detail: activeProject}))
        markBeamDesignNeedsSaved()
        autoBeamFlexureDesign()
    }
}

window.addLeftSpan = addLeftSpan

function addRightSpan() {
    const length = activeProject.beam.spans[activeProject.beam.spans.length - 1].length();
    if(!isNaN(length) && BeamManager.addRightSpan(activeProject, length)) {
        document.dispatchEvent(new CustomEvent('spans-did-change', {detail: activeProject}))
        markBeamDesignNeedsSaved()
        autoBeamFlexureDesign()
    }
}

window.addRightSpan = addRightSpan

document.getElementById('add-left-span-button').onclick = () => { 
    if(customerGate()) { 
        bootstrap.Modal.getOrCreateInstance('#modal-span-dialog').hide()
        return
    }
    addLeftSpan()
}

document.getElementById('add-right-span-button').onclick = () => { 
    if(customerGate()) { 
        bootstrap.Modal.getOrCreateInstance('#modal-span-dialog').hide()
        return
    }
    addRightSpan()
}

document.addEventListener('remove-span', (event) => {
    if(BeamManager.removeSpan(activeProject, event.detail)) {
        document.dispatchEvent(new CustomEvent('spans-did-change', {detail: activeProject}))
        markBeamDesignNeedsSaved()
        autoBeamFlexureDesign()
    }
})

document.addEventListener('span-length-changed', (event) => {
    const index = event.detail
    const spanId = `span_input_${index}`
    if(validateRequiredInput(spanId) && validateLengthInput(spanId) && validateGreaterThan(spanId, 0.0)) {
        const length = wsParseLength(document.getElementById(spanId).value)
        BeamManager.modifySpan(activeProject, index, length)
        document.dispatchEvent(new CustomEvent('spans-did-change', {detail: activeProject}))
        markBeamDesignNeedsSaved()
        autoBeamFlexureDesign()
    }
})

document.addEventListener('spans-did-change', () => {
    // update span button
    document.getElementById('span-panel-text').innerHTML = activeProject.beam.spans.length === 1 ? "1 Span" : activeProject.beam.spans.length + " Spans"
})

document.addEventListener('on-support-clicked', (event) => {
    BeamManager.cycleSupport(activeProject, event.detail)
    autoBeamFlexureDesign()
})

/*********************
 **** Load dialog ****
 *********************/
document.getElementById('show-all-load-cases-1').onchange = function() {
    showAllLoadCases = document.getElementById('show-all-load-cases-1').checked
    document.getElementById('show-all-load-cases-2').checked = showAllLoadCases
    updateLoadTable();
    currentLoadDialogToToggle();
}

document.getElementById('show-all-load-cases-2').onchange = function() {
    showAllLoadCases = document.getElementById('show-all-load-cases-2').checked
    document.getElementById('show-all-load-cases-1').checked = showAllLoadCases
    updateLoadTable();
    currentLoadDialogToToggle();
}

/************************
 **** Bracing dialog ****
 ***********************/
document.addEventListener('bracing-changed', (event) => { 
    BracingManager.updateBracingType(activeProject, event.detail)
    document.dispatchEvent(new CustomEvent('bracing-did-change', {detail: activeProject}))
    document.dispatchEvent(new CustomEvent('project-changed'))
})

document.addEventListener('equal-space-bracing-changed', (event) => { 
    BracingManager.addEquallySpacedBraces(activeProject, event.detail.braceSpacing, event.detail.braceStart)
    document.dispatchEvent(new CustomEvent('bracing-did-change', {detail: activeProject}))
    document.dispatchEvent(new CustomEvent('project-changed'))
})

document.addEventListener('add-new-brace', (event) => { 
    if (BracingManager.addBrace(activeProject, event.detail, false)) {
        document.dispatchEvent(new CustomEvent('bracing-did-change', {detail: activeProject}))
        document.dispatchEvent(new CustomEvent('project-changed'))
    }
})

document.addEventListener('remove-brace', (event) => {
    if (BracingManager.removeBrace(activeProject, event.detail)) {
        document.dispatchEvent(new CustomEvent('bracing-did-change', {detail: activeProject}))
        document.dispatchEvent(new CustomEvent('project-changed'))
    }
})

document.addEventListener('on-update-active-project-item', () => {
    configureShapeSelector()
})

function rotateBeam0Degrees() {
    if(customerGate()) { return }
    activeProject.beam.crossSectionRotation = 0
    document.dispatchEvent(new CustomEvent('project-changed'))
}

window.rotateBeam0Degrees = rotateBeam0Degrees

function rotateBeam90Degrees() {
    if(customerGate()) { return }
    activeProject.beam.crossSectionRotation = 90
    document.dispatchEvent(new CustomEvent('project-changed'))
}

window.rotateBeam90Degrees = rotateBeam90Degrees

function configureShapeSelector() {
    if (activeProject.shape.flitch) {
        document.dispatchEvent(new CustomEvent('configure-flitch-form', {detail: activeProject}))
    }
}

function onShapeOrMaterialChanged() {
    activeProject.shape = designConfigurator.shape
    activeProject.material = designConfigurator.material
    activeProject.beam.crossSectionRotation = 0
    document.dispatchEvent(new CustomEvent('design-type-did-change', {detail: activeProject}))
    document.dispatchEvent(new CustomEvent('project-changed'))
}

function autoBeamFlexureDesign() {
    // if logged in and paying customer do auto design
    // else invalidate results and highlight "Calculate" button
    if(customerLevel === "pro") {
        activeProject.analyze()
    } else {
        hideResultDisplays()
    }
}
    
jQuery(".tm-input").tagsManager({
    backspace: [],
    maxTags: 10,
});

jQuery(".tm-input").on('tm:pushed', function (e, tag) {
    activeProject.tags = jQuery(".tm-input").tagsManager('tags');
    markBeamDesignNeedsSaved();
});

jQuery(".tm-input").on('tm:spliced', function (e, tag) {
    activeProject.tags = jQuery(".tm-input").tagsManager('tags');
    markBeamDesignNeedsSaved();
});

initializeDrawingCanvas()
initializeStripe()
initializeFirebaseAuth()
initializePrintPreferencesDialog()
initializeProjectHeaderSettingsDialog()
handleQueryParameters()

const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl))


// add text box and button to bottom
// read user configs to see if this feature is enabled
const exportComponent = document.createElement('file-export-component')
document.getElementById("export-component-div").appendChild(exportComponent)

function validateRequiredInput(elementId) {
    const el = document.getElementById(elementId)
    if (el.value !== null && el.value.trim() !== "") {
        const errorDiv = document.getElementById(`${elementId}-error`)
        if (errorDiv) { errorDiv.remove() }
        return true
    } else {
        const errorDiv = document.createElement("div")
        errorDiv.id = `${elementId}-error`
        errorDiv.innerHTML = "This field is required."
        el.parentElement.appendChild(errorDiv)
        return false
    }
}

window.validateRequiredInput = validateRequiredInput

function validateLengthInput(elementId) {
    const el = document.getElementById(elementId)
    if (!isNaN(wsParseLength(el.value))) {
        const errorDiv = document.getElementById(`${elementId}-error`)
        if (errorDiv) { errorDiv.remove() }
        return true
    } else {
        const errorDiv = document.createElement("div")
        errorDiv.id = `${elementId}-error`
        errorDiv.innerHTML = "Please enter a valid length unit. For example <code>5 in</code>, <code>5 inches</code> or <code>5\"</code>"
        el.parentElement.appendChild(errorDiv)
        return false
    }
}

window.validateLengthInput = validateLengthInput

function validateLocation(elementId) {
    const el = document.getElementById(elementId)
    const location = wsParseLength(el.value)
    if (!isNaN(location) && location >= 0 && location <= activeProject.beam.TotalLength()) {
        const errorDiv = document.getElementById(`${elementId}-error`)
        if (errorDiv) { errorDiv.remove() }
        return true
    } else {
        const errorDiv = document.createElement("div")
        errorDiv.id = `${elementId}-error`
        errorDiv.innerHTML = "Position must be on the beam."
        el.parentElement.appendChild(errorDiv)
        return false
    }
}

window.validateLocation = validateLocation

function validateMinimum(elementId, minimum) {
    const el = document.getElementById(elementId)
    if (!isNaN(parseFloat(el.value)) && parseFloat(el.value) >= minimum) {
        const errorDiv = document.getElementById(`${elementId}-error`)
        if (errorDiv) { errorDiv.remove() }
        return true
    } else {
        const errorDiv = document.createElement("div")
        errorDiv.id = `${elementId}-error`
        errorDiv.innerHTML = `Number must be greater than or equal to ${minimum}`
        el.parentElement.appendChild(errorDiv)
        return false
    }
}

window.validateMinimum = validateMinimum

function validateGreaterThan(elementId, minimum) {
    const el = document.getElementById(elementId)
    if (!isNaN(parseFloat(el.value)) && parseFloat(el.value) > minimum) {
        const errorDiv = document.getElementById(`${elementId}-error`)
        if (errorDiv) { errorDiv.remove() }
        return true
    } else {
        const errorDiv = document.createElement("div")
        errorDiv.id = `${elementId}-error`
        errorDiv.innerHTML = `Number must be greater than to ${minimum}`
        el.parentElement.appendChild(errorDiv)
        return false
    }
}

window.validateGreaterThan = validateGreaterThan

function validateBraceSpacing(elementId) {
    const el = document.getElementById(elementId)
    const value = el.value
    const spacing = wsParseLength(value)
    if (!isNaN(spacing) && spacing > 0 && spacing <= activeProject.beam.TotalLength()) {
        const errorDiv = document.getElementById(`${elementId}-error`)
        if (errorDiv) { errorDiv.remove() }
        return true
    } else {
        const errorDiv = document.createElement("div")
        errorDiv.id = `${elementId}-error`
        errorDiv.innerHTML = "Brace spacing must be larger than 0 and less than or equal to the total length of the beam."
        el.parentElement.appendChild(errorDiv)
        return false
    }
}

window.validateBraceSpacing = validateBraceSpacing

function validateBraceLocation(elementId) {
    const el = document.getElementById(elementId)
    const value = el.value
    const spacing = wsParseLength(value)
    if (!isNaN(spacing) && spacing >= 0 && spacing <= activeProject.beam.TotalLength()) {
        const errorDiv = document.getElementById(`${elementId}-error`)
        if (errorDiv) { errorDiv.remove() }
        return true
    } else {
        const errorDiv = document.createElement("div")
        errorDiv.id = `${elementId}-error`
        errorDiv.innerHTML = "Brace location must be greater than or equal to 0 and less than or equal to the total length of the beam."
        el.parentElement.appendChild(errorDiv)
        return false
    }
}

window.validateBraceLocation = validateBraceLocation

function validateDistributedLoadPosition(startId, endId) {
    const start = wsParseLength(document.getElementById(startId).value)
    const end = wsParseLength(document.getElementById(endId).value)
    if (start < end) {
        const errorDiv = document.getElementById(`${endId}-error`)
        if (errorDiv) { errorDiv.remove() }
        return true
    } else {
        let errorDiv = document.getElementById(`${endId}-error`)
        if (errorDiv === null) {
            errorDiv = document.createElement("div")
            errorDiv.id = `${endId}-error`
            document.getElementById(endId).parentElement.appendChild(errorDiv)
        }
        errorDiv.innerHTML = "Start position must be less than end position."
        return false
    }
}

window.validateDistributedLoadPosition = validateDistributedLoadPosition

function validateLoadMagnitude(elementId) {
    const el = document.getElementById(elementId)
    if (!isNaN(parseFloat(el.value)) && isFinite(el.value)) {
        const errorDiv = document.getElementById(`${elementId}-error`)
        if (errorDiv) { errorDiv.remove() }
        return true
    } else {
        const errorDiv = document.createElement("div")
        errorDiv.id = `${elementId}-error`
        errorDiv.innerHTML = `Must be a number and must be finite.`
        el.parentElement.appendChild(errorDiv)
        return false
    }
}

window.validateLoadMagnitude = validateLoadMagnitude

const ENGLISH_UNITS = "english";
const METRIC_UNITS = "metric";
let gUnits = ENGLISH_UNITS;

window.gUnits = gUnits
window.ENGLISH_UNITS = ENGLISH_UNITS
window.METRIC_UNITS = METRIC_UNITS

function changeUnits(cssClassName, newUnitStr) {
    var i, elements = document.getElementsByClassName(cssClassName);
    for (i = 0; i < elements.length; i += 1) {
        elements.item(i).innerHTML = newUnitStr;
    }
}

function setUnits() {
    if (gUnits === ENGLISH_UNITS) {
        changeUnits('units-force', 'kips');
        changeUnits('units-force-per-length', 'kips/in');
        changeUnits('units-pressure', 'ksi');
        changeUnits('units-moment', 'kip-in');
        changeUnits('units-length', 'in');
    } else {
        changeUnits('units-force', 'kN');
        changeUnits('units-force-per-length', 'kN/m');
        changeUnits('units-pressure', 'kPa');
        changeUnits('units-moment', 'kN-m');
        changeUnits('units-length', 'm');
    }
}

function onEnglishUnitsClicked() {
    document.getElementById('units-selector').innerHTML = "English Units"
    window.gUnits = ENGLISH_UNITS
    document.dispatchEvent(new CustomEvent('project-changed'))
}

window.onEnglishUnitsClicked = onEnglishUnitsClicked

function onMetricUnitsClicked() {
    document.getElementById('units-selector').innerHTML = "Metric Units"
    window.gUnits = METRIC_UNITS
    document.dispatchEvent(new CustomEvent('project-changed'))
}

window.onMetricUnitsClicked = onMetricUnitsClicked

